import React from "react";
import { Result, Button } from "antd";
export default class Unauthorized extends React.Component<
  Record<string, unknown>,
  Record<string, unknown>
> {
  render(): JSX.Element {
    return (
      <div>
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to view this page."
          extra={<Button type="primary">Back Home</Button>}
        />
        ,
      </div>
    );
  }
}
